import React, { Component, Fragment } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import AppLauncher from './AppLauncher.component'
import EnterpriseManager from './EnterpriseManager.component'
import ImpersonateUser from './impersonateUser/ImpersonateUser.component'
import SiteApplicationsList from './SiteApplicationsList.component'
import SiteApplicationForm from './SiteApplicationForm.component'
import Profile from './profile/Profile.component'

import Navigation from '../navigation'

import { Box, SwxTheme } from 'swx-atomic-component-lib'

class ClippedDrawer extends Component {
  state = {
    redirect: {
      status: false,
      to: null
    },
    isGetAvatarSuccess: false
  }

  componentDidMount () {
    this.props.getAvatar().then(res => {
      if (res.data) {
        this.setState({ isGetAvatarSuccess: true })
      }
    })
  }

  onLogoutClick (e) {
    this.setState({ redirect: { status: true, to: '/login' } })
  }

  render () {
    if (this.state.redirect.status) {
      return <Redirect to={this.state.redirect.to} />
    }

    return (
      <>
        <Box customStyle={`
          width: 100%;
          height: 100%;
          background: url("/shapes-lines-large.svg");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          overflow: hidden;
        `}
        >
          <Navigation user={this.props.user} isGetAvatarSuccess={this.state.isGetAvatarSuccess} />
          <Box
            mt={20} customStyle={`
            overflow: auto;
            overflow-x: hidden;
            height: calc(100vh - 72px);
            max-height: calc(100vh - 72px);
            ::-webkit-scrollbar {
                width: 7px;
            }
            ::-webkit-scrollbar-track {
                background: ${SwxTheme.palette.g300};
            }
            ::-webkit-scrollbar-thumb {
                background: ${SwxTheme.palette.g700};
            }
            ::-webkit-scrollbar-thumb:hover {
                background: ${SwxTheme.palette.g800};
            }
          `}
          >
            <Switch>
              <Route path='/profile' component={Profile} />
              <Route path='/appLauncher' component={AppLauncher} />
              <Route path='/enterprise' component={EnterpriseManager} />
              <Route path='/impersonateUser' component={ImpersonateUser} />
              <Route path='/applications/create' component={SiteApplicationForm} />
              <Route path='/applications/:id' component={SiteApplicationForm} />
              <Route path='/applications' component={SiteApplicationsList} />
              <Redirect from='/' to='appLauncher' />
            </Switch>
          </Box>
        </Box>
      </>
    )
  }
}

ClippedDrawer.propTypes = {
  classes: PropTypes.object.isRequired
}

export default ClippedDrawer
